import { z } from 'zod';

const stepFormSchema = z.object({
  name: z.string().min(1, 'Required'),
  type: z.enum([
    'text',
    'textarea',
    'number',
    'date',
    'checkbox',
    'select',
    'radio',
  ]),
  required: z.boolean(),
  // options: z.array(
  //   z.object({
  //     name: z.string().min(1),
  //     value: z.string().min(1),
  //   }),
  // ),
});

const stepSchema = z.object({
  name: z.string().min(1, 'Required'),
  description: z.string(),
  showPassengerCounter: z.boolean().default(false),
  form: z.array(stepFormSchema),
});

export const checkListSchema = z.object({
  name: z.string().min(1, 'Required'),
  steps: z.array(stepSchema).min(1),
});

export type ICheckList = z.infer<typeof checkListSchema>;
